<div class="nav-panel nav-panel--stuck nav-panel--shown navShow  header-nav" #element>
    <div class="nav-panel__container">
        <div class="nav-panel__row" style="display: flex; justify-content: end;">
            <app-header-links class="nav-panel__nav-links nav-links"></app-header-links>
        </div>
    </div>